import { useContext } from "react";
import { WorkspaceContext } from "../providers";
import { Workspace } from "../../generated/core-api";

export function useWorkspace(): Workspace {
  const workspace = useContext(WorkspaceContext);

  if (!workspace) {
    throw new Error("useWorkspace must be used within a WorkspaceProvider");
  }

  return workspace;
}
